var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6531 18.8271L31.6537 24.9884C31.6537 26.6947 30.3217 28.0899 28.6408 28.1909L28.4454 28.1967H11.5546C9.84828 28.1967 8.4531 26.8648 8.35209 25.1839L8.34624 24.9884L8.3454 18.8271H31.6531ZM27.2951 22.9167H24.3784L24.2597 22.9246C23.8326 22.9826 23.5034 23.3487 23.5034 23.7917C23.5034 24.2346 23.8326 24.6007 24.2597 24.6587L24.3784 24.6667H27.2951L27.4138 24.6587C27.8409 24.6007 28.1701 24.2346 28.1701 23.7917C28.1701 23.3487 27.8409 22.9826 27.4138 22.9246L27.2951 22.9167ZM28.4454 11.8575C30.1517 11.8575 31.5469 13.1895 31.6479 14.8704L31.6537 15.0658L31.6531 17.0771H8.3454L8.34624 15.0658C8.34624 13.3595 9.67823 11.9643 11.3591 11.8633L11.5546 11.8575H28.4454Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.cc242933bb097e6d9a85b6119bd05f96.svg";
export { ForwardRef as ReactComponent };